module.exports = __webpack_public_path__ + "static/favicon-90b0a205a5dba5537858d6610563d571.ico";